import React from "react"
import { Layout, LoginForm} from '../../components'
import { useNavigate } from "react-router-dom"

const Login = () => {
    const navigate = useNavigate()

    return (
        <Layout justify="center">
            <LoginForm onSuccess={() => navigate('/')} />
        </Layout>
    )
}

export default Login
